import api from "../services/api";

export const baseMessageVariables = [
  { label: "Saludos", value: "{{saludo}}" },
  { label: "Apodo de contacto", value: "{{contacto_apodo}}" },
  { label: "Nombre de contacto", value: "{{contacto_nombre}}" },
  { label: "Numero de contacto", value: "{{contacto_numero}}" },
  { label: "Numero de protocolo", value: "{{numero_protocolo}}" },
  { label: "Correo electronico", value: "{{contacto_email}}" },
];

export const normalizeVariableName = value =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const customFieldToVariable = fieldName => ({
  label: fieldName,
  value: `{{custom_${normalizeVariableName(fieldName)}}}`,
});

const systemWasheetHeaders = ["id_registro", "chat_id"];

export const washeetFieldToVariable = (document, fieldName) => {
  const documentName = document.sheetName || document.name;

  return {
    label: `${documentName} > ${fieldName}`,
    value: `{{formulario.${normalizeVariableName(documentName)}.${normalizeVariableName(fieldName)}}}`,
  };
};

export const buildMessageVariables = (customFieldNames = [], extraVariables = []) => {
  const customVariables = customFieldNames.filter(Boolean).map(customFieldToVariable);
  const variables = [...baseMessageVariables, ...customVariables, ...extraVariables];
  const seen = new Set();

  return variables.filter(variable => {
    if (!variable?.value || seen.has(variable.value)) return false;
    seen.add(variable.value);
    return true;
  });
};

export const fetchContactCustomFieldNames = async () => {
  const { data } = await api.get("/contacts/custom-fields/names");
  return data.fields || [];
};

export const fetchContactCustomFieldDetails = async () => {
  const { data } = await api.get("/contacts/custom-fields/names");
  return (data.details || (data.fields || []).map(name => ({ name, fieldType: "text" })))
    .filter(field => field?.name);
};

export const fetchWasheetMessageVariables = async () => {
  const { data } = await api.get("/washeets/documents");
  const documents = data.documents || [];

  const variableGroups = await Promise.all(
    documents.map(async document => {
      try {
        const { data: sheetData } = await api.get("/washeets/read", {
          params: {
            spreadsheetId: document.spreadsheetId,
            sheetName: document.sheetName,
          },
        });

        return (sheetData.headers || [])
          .filter(header => !systemWasheetHeaders.includes(normalizeVariableName(header)))
          .map(header => washeetFieldToVariable(document, header));
      } catch {
        return [];
      }
    })
  );

  return variableGroups.flat();
};
